import {
  blue,
  grey,
  orange,
  purple,
  yellow,
  green,
} from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Theme {
    custom: {
      palette: {
        propertySources: {
          all: string;
          both: string;
          mls: string;
          pubRec: string;
          regrid: string;
        };
      };
    };
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    custom?: {
      palette?: {
        propertySources?: {
          all?: string;
          both?: string;
          mls?: string;
          pubRec?: string;
          regrid?: string;
        };
      };
    };
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: grey[900],
    },
    secondary: {
      main: blue[800],
    },
  },
  custom: {
    palette: {
      propertySources: {
        all: green[100],
        both: orange[100],
        mls: purple[100],
        pubRec: blue[100],
        regrid: yellow[100],
      },
    },
  },
});

export default theme;
